import type { ReactNode } from "react";
import { X } from "lucide-react";
import { Text, Tooltip } from "../../../DesignSystem";

export type FilterChipInfo = {
    uniqueKey?: string;
    icon: ReactNode;
    field?: string;
    operator?: string;
    description?: string | ReactNode;
    hoverText?: string;
    onClose: () => void;
};

export const FilterChipBody = (props: {
    icon: ReactNode;
    field?: string;
    operator?: string;
    description?: string | ReactNode;
    onClose?: () => void;
}) => {
    // GSTODO: Potentially swap this over to the Design System chip. I didn't do that yet because it is just different enough to warrant a custom implementation for now.
    return (
        <div className="flex w-fit items-center justify-center gap-1 rounded-full border border-stone-200 bg-stone-100 px-1.5 py-[3px] text-stone-950 select-none">
            {props.icon}
            {props.field && <Text variant="smallBody600">{props.field}</Text>}
            {props.operator && (
                <Text variant="smallBody600" className="text-stone-600">
                    {props.operator}
                </Text>
            )}
            {props.description && <Text variant="smallBody600">{props.description}</Text>}
            {props.onClose && (
                <button
                    type="button"
                    aria-label={props.field ? `Remove ${props.field} filter` : "Remove filter"}
                    className="focus-visible:shadow-focus -ml-0.5 cursor-pointer rounded-full text-stone-500 focus-visible:outline-none"
                    onClick={props.onClose}
                >
                    <X className="h-3.5 w-3.5" />
                </button>
            )}
        </div>
    );
};

export const FilterChip = (props: { info: FilterChipInfo }) => {
    const { icon, field, operator, description, hoverText, onClose } = props.info;

    const content = <FilterChipBody icon={icon} field={field} operator={operator} description={description} onClose={onClose} />;

    if (hoverText) {
        return (
            <Tooltip text={hoverText} showDelay={300}>
                {content}
            </Tooltip>
        );
    }

    return content;
};
